import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import { getAnalyticsEventLabel, useSaveForLater } from "web/react/hooks/use-save-for-later/use-save-for-later";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import withReduxProvider from "web/react/redux-provider";
import SaveForLater from "./save-for-later";
var basePropTypes = {
  className: PropTypes.string,
  cta: PropTypes.string,
  pageSource: PropTypes.oneOf(["pdp", "feed", "oos"]).isRequired,
  productId: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["icon", "small", "normal", "stockAlert"]).isRequired,
  showExpressCheckout: PropTypes.bool,
  bingTraffic: PropTypes.bool
};
export function AnonymousSFLButton(_ref) {
  var className = _ref.className,
      cta = _ref.cta,
      openCustomerCaptureOverlay = _ref.openCustomerCaptureOverlay,
      pageSource = _ref.pageSource,
      productId = _ref.productId,
      type = _ref.type,
      showExpressCheckout = _ref.showExpressCheckout,
      bingTraffic = _ref.bingTraffic;
  var trackClick = useClickTracker("save_for_later", "add_item", getAnalyticsEventLabel(pageSource), false);

  function handleClick(event) {
    trackClick(event);
    openCustomerCaptureOverlay({
      productId: productId,
      captureType: "signup_".concat(pageSource, "_save") // signup_pdp_save or signup_feed_save

    });
  }

  return React.createElement(SaveForLater, {
    className: className,
    cta: cta,
    isSaved: false,
    onClick: handleClick,
    type: type,
    showExpressCheckout: showExpressCheckout,
    bingTraffic: bingTraffic
  });
}
AnonymousSFLButton.propTypes = _objectSpread({}, basePropTypes, {
  openCustomerCaptureOverlay: PropTypes.func.isRequired
});

var _AnonymousSFLButton = withReduxProvider(connect(null, {
  openCustomerCaptureOverlay: openCustomerCaptureOverlay
})(AnonymousSFLButton));

export function AuthenticatedSFLButton(_ref2) {
  var className = _ref2.className,
      cta = _ref2.cta,
      initialIsSaved = _ref2.initialIsSaved,
      pageSource = _ref2.pageSource,
      productId = _ref2.productId,
      type = _ref2.type,
      showExpressCheckout = _ref2.showExpressCheckout,
      bingTraffic = _ref2.bingTraffic;

  var _useSaveForLater = useSaveForLater(productId, pageSource, initialIsSaved),
      _useSaveForLater2 = _slicedToArray(_useSaveForLater, 4),
      isSaved = _useSaveForLater2[0],
      toggleSaved = _useSaveForLater2[2],
      isSaving = _useSaveForLater2[3];

  if (isSaved == null) {
    isSaved = false;
  }

  return React.createElement(SaveForLater, {
    className: className,
    cta: cta,
    isSaved: isSaved,
    isSaving: isSaving,
    onClick: toggleSaved,
    type: type,
    showExpressCheckout: showExpressCheckout,
    bingTraffic: bingTraffic
  });
}
AuthenticatedSFLButton.propTypes = _objectSpread({}, basePropTypes, {
  initialIsSaved: PropTypes.bool
});

function SaveForLaterButton(_ref3) {
  var isLoggedIn = _ref3.isLoggedIn,
      props = _objectWithoutProperties(_ref3, ["isLoggedIn"]);

  if (isLoggedIn) {
    return React.createElement(AuthenticatedSFLButton, props);
  } else {
    return React.createElement(_AnonymousSFLButton, props);
  }
}

export default SaveForLaterButton;
SaveForLaterButton.propTypes = _objectSpread({}, basePropTypes, {
  isLoggedIn: PropTypes.bool.isRequired
});
SaveForLaterButton.defaultProps = {
  type: "normal"
};